import { withRouter } from 'react-router-dom';
import withErrorCatcher from 'framework/components/hoc/withErrorCatcher';
import PageComponent from './Page';

export default withErrorCatcher(withRouter(PageComponent));
